import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LoggerService } from '@sko/ng-logging';
import { fetchAuthSession } from 'aws-amplify/auth';

export const authedGuard: CanActivateFn = () => {
  
  const logger = inject(LoggerService);

  return fetchAuthSession()
  .then((session) => {

    logger.info({ session }, 'authedGuard');

    return (session.tokens?.idToken) ? true : false;

  })
  .catch((e) => {

    logger.error(e);

    return false;

  });
  
};
